import { PopoverProps } from '@radix-ui/react-popover';

import { HTMLDataTrackerProps } from '@/app/types';
import {
  PopupImageLinkStrapi,
  PopupImageLinkStrapiProps,
} from '@/decodo/components/atoms/PopupImageLink/PopupImageLinkStrapi';

import { SocialWidgetEntry } from './SocialWidgetStrapi';
import TogglePopover, { TogglePopoverProps } from './TogglePopover';

type SocialWidgetItemListProps = SocialWidgetEntry & {
  handleSelectCallback: () => void;
  PopupProps?: Partial<PopoverProps>;
} & HTMLDataTrackerProps;

const isTogglePopover = (
  props: SocialWidgetItemListProps
): props is SocialWidgetItemListProps => {
  if (!props.popup) return false;
  if (props.popup.length < 2) return false;
  if (!props.tab) return false;

  return true;
};

const SocialWidgetItem = (props: SocialWidgetItemListProps) => {
  const { handleSelectCallback, link, popup, PopupProps, icon, tab } = props;

  const transformedSingleEntryProps: PopupImageLinkStrapiProps = {
    inner: {
      link: {
        variant: 'text',
        ...link,
      },
      popupImage: {
        className: 'w-36 h-auto',
        'data-tracker-context': props['data-tracker-context'],
      },
      popup: {
        position: 'left',
        showArrow: true,
        onChangeCallback: handleSelectCallback,
        classNames: {
          arrow: 'fill-base-white',
          childrenWrapper: 'border-none shadow-xl rounded-lg',
        },
        contentProps: {
          className: 'p-0 border-none w-42',
          sideOffset: 24,
        },
        ...PopupProps,
      },
      image: {
        className: 'h-6 w-6',
        ...icon,
        'data-tracker-context': props['data-tracker-context'],
      },
    },
    block: {
      image: icon,
      link: link,
      popup: popup?.[0],
    },
  };

  // use a popover toggle if there are more than 2 entries in the popup array
  if (isTogglePopover(props) && !!tab && !!popup) {
    const { block } = transformedSingleEntryProps;

    const transformedTabbedEntryProps: TogglePopoverProps = {
      ...transformedSingleEntryProps,
      block: {
        ...block,
        popups: popup,
      },
      tab: tab,
    };

    return <TogglePopover {...transformedTabbedEntryProps} />;
  }

  return <PopupImageLinkStrapi {...transformedSingleEntryProps} />;
};

export default SocialWidgetItem;
